import { BaseModel } from './base';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export class Damage extends BaseModel {
    public area_description: string;
    public comment: string;
    public area_all: boolean;
    public area_underbody: boolean;
    public area_interior: boolean;
    public area_front_left: boolean;
    public area_front_center: boolean;
    public area_front_right: boolean;
    public area_center_left: boolean;
    public area_center_right: boolean;
    public area_rear_left: boolean;
    public area_rear_center: boolean;
    public area_rear_right: boolean;
    public area_roof: boolean;
    public fire: boolean;
    public water: boolean;
    public graphic_key: string;
    public graphic_name: string;
    public damaged_parts: string;

    public readonly trans = {
        area_description: marker('damage.area_description'),
        comment: marker('damage.comment'),
        area_all: marker('damage.area_all'),
        area_underbody: marker('damage.area_underbody'),
        area_interior: marker('damage.area_interior'),
        area_front_left: marker('damage.area_front_left'),
        area_front_center: marker('damage.area_front_center'),
        area_front_right: marker('damage.area_front_right'),
        area_center_left: marker('damage.area_center_left'),
        area_center_right: marker('damage.area_center_right'),
        area_rear_left: marker('damage.area_rear_left'),
        area_rear_center: marker('damage.area_rear_center'),
        area_rear_right: marker('damage.area_rear_right'),
        area_roof: marker('damage.area_roof'),
        fire: marker('damage.fire'),
        water: marker('damage.water'),
        damaged_parts: marker('damage.damaged_parts')
    };

    constructor(json?: any) {
        super(json);
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            area_all: json && json.area_all,
            area_underbody: json && !!json.area_underbody,
            area_interior: json && !!json.area_interior,
            area_front_left: json && !!json.area_front_left,
            area_front_center: json && !!json.area_front_center,
            area_front_right: json && !!json.area_front_right,
            area_center_left: json && !!json.area_center_left,
            area_center_right: json && !!json.area_center_right,
            area_rear_left: json && !!json.area_rear_left,
            area_rear_center: json && !!json.area_rear_center,
            area_rear_right: json && !!json.area_rear_right,
            area_roof: json && !!json.area_roof,
            fire: json && !!json.fire,
            water: json && !!json.water
        });
    }
}
